/** ARIA role tokens -- SSOT for the `role="..."` literals across `components/`. Strings are NOT auto-prefixed: raw ARIA role names are the contract. */

import type { AriaLive, AriaRole } from '@federa/types/ui-icons';

/** Canonical ARIA role values for `role="..."` attributes. */
export const ARIA_ROLES = {
	alert: 'alert',
	status: 'status',
	dialog: 'dialog',
	alertdialog: 'alertdialog',
	button: 'button',
	link: 'link',
	menu: 'menu',
	menuitem: 'menuitem',
	menubar: 'menubar',
	tab: 'tab',
	tablist: 'tablist',
	tabpanel: 'tabpanel',
	list: 'list',
	listitem: 'listitem',
	listbox: 'listbox',
	option: 'option',
	group: 'group',
	radiogroup: 'radiogroup',
	radio: 'radio',
	checkbox: 'checkbox',
	switch: 'switch',
	combobox: 'combobox',
	progressbar: 'progressbar',
	separator: 'separator',
	navigation: 'navigation',
	banner: 'banner',
	main: 'main',
	region: 'region',
	complementary: 'complementary',
	contentinfo: 'contentinfo',
	search: 'search',
	form: 'form',
	presentation: 'presentation',
	tooltip: 'tooltip',
	grid: 'grid',
	columnheader: 'columnheader',
	img: 'img',
	/** A grid whose rows expand into child rows: the one table role that admits `aria-expanded` on a row (2026-09-11). */
	treegrid: 'treegrid',
	toolbar: 'toolbar',
	/** A figure that moves on its own -- a running meter (2026-09-18): named once, never announced per tick. */
	timer: 'timer',
} as const satisfies Record<AriaRole, AriaRole>;

/** Canonical `aria-live` politeness values; consumers read via `ARIA_LIVE.polite` / `.assertive` / `.off` to keep inline literals refactor-safe. */
export const ARIA_LIVE = {
	polite: 'polite',
	assertive: 'assertive',
	off: 'off',
} as const satisfies Record<AriaLive, AriaLive>;

/** `type="button"` is the deliberate default inside a form context, overriding HTML's `submit`. Paired forbid-rule QUAL-BUTTON-TYPE-EXPLICIT-001 consumes this SSOT. */
export const BUTTON_TYPE = {
	button: 'button',
	submit: 'submit',
	reset: 'reset',
} as const;
